import React from 'react'
import Sidebar from '../sidebar/sidebar'
import image from "../../assets/images/Unified-Corporate-ReportingApplication-min.png"

const Ucreports = () => {
  return (
    <>
     <div className="home-container">
      <Sidebar/>
      <div className="home-content">
        <img
              src={image} // Replace with your image URL
          alt="Clients"
          className="home-image"
        />
      </div>
    </div>
    </>
  )
}

export default Ucreports